export const limitedAccountCreateRouteName = 'limitedAccountCreate';
